export enum LocalStorageKey {
  activeStation = 'active-station',
  initialOccupation = 'initial-occupation',
}
